import React from 'react';
import PropTypes from 'prop-types';

const SearchReverse = ({ color = '#838b93' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M12.2082273,13.3383595 C10.9210635,14.3776733 9.28320783,15 7.5,15 C3.35786438,15 0,11.6421356 0,7.5 C0,3.35786438 3.35786438,0 7.5,0 C11.6421356,0 15,3.35786438 15,7.5 C15,9.28320783 14.3776733,10.9210635 13.3383595,12.2082273 C13.3476214,12.2166665 13.3567331,12.2253623 13.3656854,12.2343146 L17.7656854,16.6343146 C18.0781049,16.946734 18.0781049,17.453266 17.7656854,17.7656854 C17.453266,18.0781049 16.946734,18.0781049 16.6343146,17.7656854 L12.2343146,13.3656854 C12.2253623,13.3567331 12.2166665,13.3476214 12.2082273,13.3383595 Z M7.5,13 C10.5375661,13 13,10.5375661 13,7.5 C13,4.46243388 10.5375661,2 7.5,2 C4.46243388,2 2,4.46243388 2,7.5 C2,10.5375661 4.46243388,13 7.5,13 Z"
                id="search-rev-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/UI/search_rev"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#search-rev-path-1" />
            </mask>
            <use
                id="Mask"
                fill={color}
                transform="translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) "
                xlinkHref="#search-rev-path-1"
            />
        </g>
    </svg>
);

SearchReverse.propTypes = {
    color: PropTypes.string,
};

export default SearchReverse;
